<template>
    <placeholder-panel class="user-placeholder">
        <h1 class="display-4 text-center mb-2">
            👈
        </h1>
        <h5 class="text-center font-weight-bold mb-0">
            請選擇用戶
        </h5>
    </placeholder-panel>
</template>

<script>
    import PlaceholderPanel from "../PlaceholderPanel";
    export default {
        name: "UserPlaceholderPanel",
        components: {
            PlaceholderPanel
        },
        data () {
            return {

            };
        },
        computed: {

        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    .user-placeholder {

    }
</style>
